import { bootstrapApplication } from '@angular/platform-browser';

import * as Sentry from '@sentry/angular';

import { environment } from '@kr/environment';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  Sentry.init({
    dsn: 'https://0fd3558da0c552104f5fee5708784e49@o4507463006683136.ingest.de.sentry.io/4507978991599696',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['https://kryptonite.cryptobit.live'],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

bootstrapApplication(AppComponent, appConfig).catch(err => Sentry.captureException(err));
